import React, { useEffect, useState } from 'react';
import { Field, Schema } from 'utils/SchemaUtils';
import { InspectionAndFieldTestActions, updateInspection } from 'utils/InspectionsUtils';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import { FormProvider } from 'context/FormContext';
import { useFormContext } from 'hooks/useFormContext';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';
import { useFormikContext } from 'formik';

const rejectedStatusId = "c73baf98-abae-e211-bec0-000c299e1962";

const FormHitchHiker = ({ isRejected }) => {
  const { values } = useFormikContext();

  useEffect(() => {
    isRejected(values.inspectionStatusId);
  }, [values.inspectionStatusId, isRejected]);
  return null
};

// this components somewhat buggy. I've had issues with it, just so many states to manage + form provider state.
// this component modifies the values presented in status based on 
const ReviewInspectionForm = ({ inspection, fieldTests, refresh, close, disabled = false }) => {
  const { InspectionId: inspectionId, Description_InspectionStatus } = inspection;
  // local state variable to hook into and forcibly update the data;
  const [refreshForm, setRefreshForm] = useState(new Date());
  const [rejectedStatus, setRejectedStatus] = useState("");
  const formContext = useFormContext();

  // update available status IDs in schema based on field tests and current status.
  // this fires when props change, or inspectionStatusId changes
  useEffect(() => {
    let mounted = true;
    function filterOptions() {
      let changes = false;
      let newSchema = formContext.schema;
      try {
        // get available status Ids
        const actions = InspectionAndFieldTestActions.determineActions(Description_InspectionStatus, fieldTests);
        // filter the domain values and modify the schema to have filtered domains
        if (formContext.definitions[newSchema.properties.inspectionStatusId.$ref]) {
          changes = true;
          const defs = formContext.definitions[newSchema.properties.inspectionStatusId.$ref].oneOf.filter(r => actions.includes(r.title));
          const status = { ...newSchema.properties.inspectionStatusId, oneOf: defs };
          delete status.$ref;
          newSchema = { ...newSchema, properties: { ...newSchema.properties, inspectionStatusId: status } };
        };

        mounted && changes && formContext.updateSchema(newSchema);
      } catch (e) {
        console.error(e);
      }
    };
    // return InspectionAndFieldTestActions.determineActions(Description_InspectionStatus, fieldTests)
    formContext.ready && formContext.schema.properties.inspectionStatusId.$ref && mounted && filterOptions();
    return () => {
      mounted = false;
    }
  }, [rejectedStatus, fieldTests, formContext, Description_InspectionStatus]);

  useEffect(() => {
    const update = formContext.updateSchema;
    const updateSchema = () => {
      const reviewInspSchema = new Schema("Review Inspection");
      reviewInspSchema.addField(new Field({ fieldName: "inspectionStatusId", type: 'string', label: "Status", $ref: "/api/Domain?domainName=LuInspectionState&includeReserved=false", required: true, nullable: true }));
      reviewInspSchema.addField(new Field({ fieldName: 'comments', type: 'string', label: 'Comments', required: false }));
      update(reviewInspSchema);
    }

    updateSchema();
  }, [inspectionId, formContext.updateSchema]);



  const RenderForm = React.useCallback(() => {

    const handleSubmit = async (data, submit) => {
      const payload = {
        InspectionStatusId: data.inspectionStatusId,
        comments: data.comments
      }

      const result = await updateInspection(inspectionId, payload);

      if (result.success) {
        setTimeout(() => { refresh(); setRefreshForm(new Date()); close(); }, 800);
      };

      return result;
    };

    let schema = formContext.schema;
    
    // react to if the status is rejected, if so add comments to required fields,
    // else remove comments;
    if (rejectedStatus === rejectedStatusId) {
      if (!schema.required.includes("comments")) {
        schema = { ...schema, required: [...schema.required, "comments"] };
      };
    } else {
      const _required = [...schema.required];
      _required.includes("comments")  && _required.splice(_required.indexOf("comments"), 1);
      schema = { ...schema, required: _required };
    };

    const Form = () => withExtension(DynamicForm,
      {
        schema: schema,
        disabledProperties: ["User"],
        onSubmit: async (e) => {
          return await handleSubmit(e);
        },
        inputVariant: "standard",
        definitions: formContext.definitions,
        title: true,
        disabled,
        children: <FormHitchHiker isRejected={ (e) => { setRejectedStatus(e) } } />,
        defaultValues: rejectedStatus !== "" ? { inspectionStatusId: rejectedStatus } : { inspectionStatusId: "" }
      }
    )

    return (formContext.ready && <Form></Form>)
  }, [rejectedStatus, inspectionId, refresh, formContext.ready, formContext.definitions, formContext.schema, disabled, close])

  return (
    <>
      {formContext.ready ? <RenderForm /> : <CenteredCircularProgress />}
    </>
  )
};

// wrap form in from provider to get formContext hooks;
const WrappedForm = ({ ...props }) => {
  return <FormProvider><ReviewInspectionForm {...props} /></FormProvider>
}

export default WrappedForm;